import jwtDecode from "jwt-decode";

const TENANT_QUERY_PARAM = "tenantId";

export const normalizeTenantId = (value) =>
  value == null ? "" : String(value).trim().toLowerCase();

const getTenantIdFromSearch = (search = "") =>
  normalizeTenantId(new URLSearchParams(search).get(TENANT_QUERY_PARAM));

export const getRequestedTenantId = (location = {}) => {
  const stateTenantId = normalizeTenantId(location.state?.tenantId);
  if (stateTenantId) return stateTenantId;

  const searchTenantId = getTenantIdFromSearch(location.search);
  if (searchTenantId) return searchTenantId;

  const redirectPath = location.state?.from;
  if (typeof redirectPath !== "string") return "";

  const queryIndex = redirectPath.indexOf("?");
  return queryIndex >= 0
    ? getTenantIdFromSearch(redirectPath.slice(queryIndex))
    : "";
};

export const getAuthenticatedTenantId = () => {
  try {
    const accessToken = window.localStorage.getItem("access_token");
    return accessToken
      ? normalizeTenantId(jwtDecode(accessToken)?.idTenant)
      : "";
  } catch {
    return "";
  }
};
